export default "__VITE_ASSET__Q70Pxhqn__"